var map = {
	"./ambasada.svg": 78,
	"./apteka.svg": 79,
	"./awaria-samochodu.svg": 80,
	"./dots.svg": 55,
	"./en.svg": 42,
	"./formularze.svg": 56,
	"./fr.svg": 43,
	"./granica.svg": 81,
	"./help logo.svg": 82,
	"./info-solid.svg": 51,
	"./kradziez.svg": 83,
	"./lekarz.svg": 84,
	"./leki.svg": 28,
	"./nagly-wypadek-zdrowotny.svg": 85,
	"./pl.svg": 44,
	"./prawnik.svg": 86,
	"./ru.svg": 45,
	"./szpital.svg": 87,
	"./tlumacz.svg": 38,
	"./unlock-alt-solid.svg": 64,
	"./ustawienia.svg": 46,
	"./wypadek-samochodowy.svg": 88
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;